import { render, staticRenderFns } from "./MiraAnimatedText.vue?vue&type=template&id=7cbc7022&"
import script from "./MiraAnimatedText.vue?vue&type=script&lang=ts&"
export * from "./MiraAnimatedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports